import { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import TeacherShell, { TeacherPageHeader } from '../../../components/layout/TeacherShell';
import { Card, Button, Input, Textarea, InputLabel, InputGroup } from '../../../components/ui';

export default function UnitsNew({ course }) {
  const [formData, setFormData] = useState({ title: '', description: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    router.post(`/teacher/courses/${course.id}/units`, { unit: formData }, {
      onFinish: () => setIsSubmitting(false),
    });
  };

  return (
    <TeacherShell scrollTitle={<><Link href={`/teacher/courses/${course.id}`} className="hover:text-blue-600 dark:hover:text-blue-400">{course.title}</Link>{'  ›  New Unit'}</>}>
      <TeacherPageHeader
        title="New Unit"
        subtitle={`in ${course.title}`}
        backLink={`/teacher/courses/${course.id}`}
        backLabel={`Back to ${course.title}`}
      />

      <div className="max-w-2xl">
        <Card className="p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <InputGroup>
              <InputLabel htmlFor="title" required>Title</InputLabel>
              <Input
                id="title"
                value={formData.title}
                onChange={handleChange('title')}
                placeholder="e.g., Unit 3: Persuasive Writing"
              />
            </InputGroup>

            <InputGroup>
              <InputLabel htmlFor="description">Description</InputLabel>
              <Textarea
                id="description"
                value={formData.description}
                onChange={handleChange('description')}
                rows={3}
                placeholder="What students will learn in this unit..."
              />
            </InputGroup>

            <div className="flex items-center gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
              <Button type="submit" variant="primary" disabled={isSubmitting || !formData.title.trim()}>
                {isSubmitting ? 'Creating...' : 'Create Unit'}
              </Button>
              <Link href={`/teacher/courses/${course.id}`}>
                <Button type="button" variant="ghost">Cancel</Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </TeacherShell>
  );
}
